import downloadTrack from '../downloadTrack';

export default host => (id) => downloadTrack(host, id, 'musicVersion')
